import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

export const BusinessInfoSection = ({ formData, handleChange }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div>
      <Label htmlFor="legal_business_name">Legal Business Name</Label>
      <Input id="legal_business_name" value={formData.legal_business_name} onChange={(e) => handleChange('legal_business_name', e.target.value)} />
    </div>
    <div>
      <Label htmlFor="ein_tax_id">EIN/Tax ID</Label>
      <Input id="ein_tax_id" value={formData.ein_tax_id} onChange={(e) => handleChange('ein_tax_id', e.target.value)} />
    </div>
    <div>
      <Label htmlFor="business_type">Business Type</Label>
      <Select value={formData.business_type} onValueChange={(value) => handleChange('business_type', value)}>
        <SelectTrigger><SelectValue placeholder="Select type" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="LLC">LLC</SelectItem>
          <SelectItem value="Corporation">Corporation</SelectItem>
          <SelectItem value="Sole Proprietorship">Sole Proprietorship</SelectItem>
          <SelectItem value="Partnership">Partnership</SelectItem>
        </SelectContent>
      </Select>
    </div>
    <div>
      <Label htmlFor="years_in_business">Years in Business</Label>
      <Input id="years_in_business" type="number" value={formData.years_in_business} onChange={(e) => handleChange('years_in_business', e.target.value)} />
    </div>
    <div>
      <Label htmlFor="monthly_revenue">Monthly Revenue</Label>
      <Input id="monthly_revenue" type="number" step="0.01" value={formData.monthly_revenue} onChange={(e) => handleChange('monthly_revenue', e.target.value)} />
    </div>
    <div className="md:col-span-2">
      <Label htmlFor="business_address">Business Address</Label>
      <Input id="business_address" value={formData.business_address} onChange={(e) => handleChange('business_address', e.target.value)} />
    </div>
  </div>
);

export const OwnerInfoSection = ({ formData, handleChange }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div>
      <Label htmlFor="owner_name">Owner Name</Label>
      <Input id="owner_name" value={formData.owner_name} onChange={(e) => handleChange('owner_name', e.target.value)} />
    </div>
    <div>
      <Label htmlFor="owner_ssn">Owner SSN</Label>
      <Input id="owner_ssn" value={formData.owner_ssn} onChange={(e) => handleChange('owner_ssn', e.target.value)} placeholder="XXX-XX-XXXX" />
    </div>
    <div>
      <Label htmlFor="owner_dob">Date of Birth</Label>
      <Input id="owner_dob" type="date" value={formData.owner_dob} onChange={(e) => handleChange('owner_dob', e.target.value)} />
    </div>
    <div>
      <Label htmlFor="owner_phone">Owner Phone</Label>
      <Input id="owner_phone" value={formData.owner_phone} onChange={(e) => handleChange('owner_phone', e.target.value)} />
    </div>
    <div>
      <Label htmlFor="owner_email">Owner Email</Label>
      <Input id="owner_email" type="email" value={formData.owner_email} onChange={(e) => handleChange('owner_email', e.target.value)} />
    </div>
    <div className="md:col-span-2">
      <Label htmlFor="owner_address">Owner Address</Label>
      <Input id="owner_address" value={formData.owner_address} onChange={(e) => handleChange('owner_address', e.target.value)} />
    </div>
    <div className="md:col-span-2">
      <Label htmlFor="notes">Notes</Label>
      <textarea id="notes" className="w-full min-h-[100px] px-3 py-2 border rounded-md" value={formData.notes} onChange={(e) => handleChange('notes', e.target.value)} />
    </div>
  </div>
);

export const ParticipantsSection = ({ formData, handleChange, brokers, funders, SearchableCombobox, getBrokerLabel, getFunderLabel }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div>
      <Label htmlFor="broker_id">Broker/ISO *</Label>
      <SearchableCombobox
        value={formData.broker_id}
        options={brokers}
        onChange={(val) => handleChange('broker_id', val)}
        placeholder="Type to search brokers/ISOs..."
        getId={(b) => b.id}
        getLabel={getBrokerLabel}
        renderOption={(b) => (
          <span>{b.company_name}{' '}<span className="text-xs text-muted-foreground">{(b.contact_types || []).includes('ISO') ? '(ISO)' : '(Broker)'}</span></span>
        )}
      />
    </div>
    <div className="flex items-end">
      <label className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer" htmlFor="is_iso_originated_new">
        <input id="is_iso_originated_new" type="checkbox" checked={formData.is_iso_originated === true} onChange={(e) => handleChange('is_iso_originated', e.target.checked)} data-testid="new-deal-iso-checkbox" />
        Is this an ISO deal? (+2% syndicator charge)
      </label>
    </div>
    <div>
      <Label htmlFor="funder_id">Funder *</Label>
      <SearchableCombobox
        value={formData.funder_id}
        options={funders}
        onChange={(val) => handleChange('funder_id', val)}
        placeholder="Type to search funders..."
        getId={(f) => f.id}
        getLabel={getFunderLabel}
      />
    </div>
    <div>
      <Label htmlFor="commission_type">Commission Type</Label>
      <Select value={formData.commission_type} onValueChange={(value) => handleChange('commission_type', value)}>
        <SelectTrigger><SelectValue placeholder="Select type" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="iso">ISO %</SelectItem>
          <SelectItem value="broker">Broker %</SelectItem>
        </SelectContent>
      </Select>
    </div>
    <div>
      <Label htmlFor="commission_rate">Commission Rate (%)</Label>
      <Input id="commission_rate" type="number" step="0.01" value={formData.commission_rate} onChange={(e) => handleChange('commission_rate', e.target.value)} placeholder="Enter % rate" />
    </div>
  </div>
);
